import { css, cx } from 'linaria';
import { buttonReset } from 'components/buttons/button-reset';
import { Trans } from 'next-i18next';
const tabAction = "t1gozoof";
export function SelectShareType({
  active,
  activate
}) {
  return <div className={cx(tabAction, 'tabs')}>
      <ShareTypeTab active={active} activate={activate} tab="social">
        <Trans i18nKey="share:social-media">Social Media</Trans>
      </ShareTypeTab>

      <ShareTypeTab active={active} activate={activate} tab="recommend">
        <Trans i18nKey="share:recommend">Recommend</Trans>
      </ShareTypeTab>

      {
      /*
       // Deprecated Feb 2, 2021
       <ShareTypeTab active={active} activate={activate} tab="friend">
         <Trans i18nKey="share:send-to-friend">Send to Friend</Trans>
       </ShareTypeTab>
      */
    }
    </div>;
}

function ShareTypeTab({
  active,
  activate,
  tab,
  children
}) {
  const onClick = () => activate(tab);

  const isActive = active === tab;
  return <button data-cy={`share-tab-${tab}`} onClick={onClick} className={cx(buttonReset, isActive ? 'active' : null)}>
      {children}
    </button>;
}

require("./select-share-type.linaria.module.css!=!../../../node_modules/linaria/lib/outputCssLoader.js?cacheProvider=!./select-share-type.js");